<template>
  <!-- ##### จัดการระดับตำแหน่ง ##### -->
  <div>
    <!-- ##### ช่องค้นหา ##### -->
      <v-row class="pa-5 mb-5">
        <v-col cols="12" sm="6" md="6" lg="4" class="pt-0 pb-0">
          <v-autocomplete
            v-model="positionGroupName"
            :items="positionGroupNameList"
            item-text="positionGroupName"
            clearable
            outlined
            dense
            class="mt-2"
            placeholder="ค้นหาจากชื่อกลุ่ม"
            no-data-text="ไม่พบข้อมูล"
            @keyup="getSelectGroupName($event.target.value)"
            @change="searchFilterData(), page=1"
            @click:clear="positionGroupName = '', page=1"
          >
          <template v-slot:append>
            <img width="18" height="18" src="@/assets/icons/search-icon-2.png" style="cursor: pointer;" @change="searchFilterData(), page=1">
          </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="1" class="">
        <v-btn
          class="button-color-outline"
          outlined
          @click="clearValue"
          >
          ล้างข้อมูล
        </v-btn>
        </v-col>
        <v-spacer/>
        <!-- ##### ปุ่มเพิ่มระดับตำแหน่ง ##### -->
        <v-col cols="2" lg="2" md="2" sm="2" xs="2" class="pt-0 pb-0 d-flex align-center justify-end mt-1">
          <v-btn
            class="button-color"
            style="width: 195px; height:36px; border-radius:6px;"
            elevation="0"
            dark
            @click="addDialog()"
          >
            <v-icon left dark color="#fff" size="14px">mdi-plus</v-icon>
            เพิ่มกลุ่มระดับตำแหน่ง
          </v-btn>
        </v-col>
        <!-- ##### ตาราง ##### -->
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="groupPositionLevelList"
            class="border-table-employee"
            :loading="loading"
            loading-text="Loading... Please wait"
            :footer-props="{
              'items-per-page-options': [15, 30, 50, 100, -1],
              'items-per-page': 15
            }"
            :server-items-length="total || -1"
            @update:items-per-page="changePerPage"
            @update:page="changePage"
            :page.sync="page"
            :items-per-page="perPage"
            hide-default-footer
            @page-count="pageCount = $event"
          >
            <template v-slot:[`item.no`]="{ item }">
              {{ (perPage*(page-1)) + groupPositionLevelList.indexOf(item)+1 }}
            </template>
            <template v-slot:[`item.data-table-expand`]="{item}">
              <!-- <v-menu close-on-click bottom offset-y>
                <template v-slot:activator="{ on: menu, attrs }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on: tooltip }">
                      <v-btn
                        v-bind="attrs"
                        v-on="{ ...menu, ...tooltip }"
                        rounded
                        dark
                        small
                        icon
                        class="mt-3 mb-3 ml-2"
                      >
                        <template v-slot>
                          <v-icon dark size="20" class="icon-eye-color">mdi-pencil-outline</v-icon>
                        </template>
                      </v-btn>
                    </template>
                    <span>จัดการกลุ่ม</span>
                  </v-tooltip>
                </template>
                <v-list>
                  <v-list-item v-for="(list, key) in menuEdit" :key="key" @click="handleMenuEdit(list, item)">
                    <v-icon dark size="20" class="icon-eye-color mr-2">{{ list.icon }}</v-icon>
                    <span style="white-space: nowrap;">{{ list.title }}</span>
                  </v-list-item>
                </v-list>
              </v-menu> -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    rounded
                    dark
                    small
                    icon
                    class="mt-3 mb-3 ml-2"
                    @click="openDialogAddPositionInGroup(item)"
                  >
                    <template v-slot>
                      <v-icon dark size="20" class="icon-eye-color">mdi-pencil-outline</v-icon>
                    </template>
                  </v-btn>
                </template>
                <span>จัดการกลุ่ม</span>
              </v-tooltip>
              <!-- <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    rounded
                    dark
                    small
                    icon
                    class="mt-3 mb-3 ml-2"
                    @click="editLevel(item)"
                  >
                  <template v-slot>
                    <v-icon dark size="20" class="icon-eye-color">mdi-pencil-outline</v-icon>
                  </template>
                  </v-btn>
                </template>
                <span class="label-table-action">แก้ไขระดับตำแหน่ง</span>
              </v-tooltip> -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    rounded
                    dark
                    small
                    icon
                    class="mt-3 mb-3 ml-2"
                    @click="deleteGroup(item._id)"
                  >
                  <template v-slot>
                    <v-icon dark size="20" color="error">mdi-delete-outline</v-icon>
                  </template>
                  </v-btn>
                </template>
                <span class="label-table-action">ลบข้อมูล</span>
              </v-tooltip>
            </template>
          </v-data-table>
          <v-row>
            <v-col cols="12" class="pa-0">
            <div class="justify-end d-flex align-end pt-4">
              <v-pagination
                v-model="page"
                :length="pageCount"
                :total-visible="5"
              ></v-pagination>
            </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    <v-dialog v-model="dialogConfirmDel" max-width="400px">
      <v-card height="180px" style="border-radius: 12px;">
        <v-card-title class="button-color-outline ra-head-text-bold justify-center pa-5" style="font-size: 18px">ต้องการลบข้อมูลนี้ใช่หรือไม่</v-card-title>
        <v-card-text class="justify-center text-center">
        <span class="ra-head-text justify-center" style="font-size: 16px">หากยืนยัน จะทำการลบกลุ่มออกจากระบบ</span>
        <!-- <span v-else-if="titleDialog === 'temporaryer'" class="ra-head-text justify-center">คุณแน่ใจหรือว่าต้องการลบข้อมูลผู้รักษาการคนนี้</span> -->
        </v-card-text>
        <v-card-actions class="">
          <v-spacer></v-spacer>
          <v-btn class="button-color-outline pl-5 pr-5 mr-3" style="border-radius: 6px;" outlined @click="dialogConfirmDel = false">ยกเลิก</v-btn>
          <v-btn class="button-color pl-5 pr-5" style="border-radius: 6px;" dark @click="deletePositionData()">ยืนยัน</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <OverlayLoading :loading="loading" />
    <DialogAddGroup />
    <DialogAddPositionInGroup />
    <DialogUpdateGroupName />
    <DialogUpdateGroupPosition />
  </div>
</template>

<script>
import {
  getPositionLevelGroupList,
  deletePositionGroup,
  searchPositionLevelGroup
} from '@/API/API'
import { EventBus } from '@/EventBus'
import DialogUpdateGroupPosition from './_dialog/dialogUpdateGroupPosition.vue'
import DialogAddPositionInGroup from './_dialog/dialogAddPositionLevelInGroup.vue'
import DialogUpdateGroupName from './_dialog/dialogUpdateGroupName.vue'
import DialogAddGroup from './_dialog/dialogAddGroup.vue'
import OverlayLoading from '../_template/OverlayLoading.vue'
import swal from 'sweetalert'
const moment = require('moment')

export default {
  data () {
    return {
      positionGroupName: '',
      positionGroupNameList: [],
      filterData: {
        companyType: ''
      },
      tokenUser: '',
      loading: false,
      groupCompanyList: [],
      groupPositionLevelList: [],
      debounce: null,
      debounceTime: 500,
      headers: [
        {
          text: 'ลำดับ',
          align: 'center',
          value: 'no',
          width: '6%',
          sortable: false
        },
        { text: 'กลุ่มระดับตำแหน่ง', value: 'positionGroupName', sortable: false, align: 'center' },
        // { text: 'ระดับตำแหน่ง', value: 'number', sortable: false, align: 'center' },
        { text: 'วันที่สร้าง', value: 'createAt', sortable: false },
        { text: 'วันที่แก้ไข', value: 'updateAt', sortable: false },
        { text: 'จัดการ', value: 'data-table-expand', sortable: false, width: '195px', align: 'center fixed', class: 'column-fix' }
      ],
      menuEdit: [
        { title: 'ดูตำแหน่งภายในกลุ่ม', icon: 'mdi-eye-outline', type: 'viewPositionInGroup' },
        { title: 'แก้ไขชื่อกลุ่ม', icon: 'mdi-pencil-outline', type: 'editGroupName' },
        { title: 'แก้ไขตำแหน่งในกลุ่ม', icon: 'mdi-pencil-outline', type: 'editPositionInGroup' }
      ],
      total: -1,
      perPage: 15,
      pageCount: 0,
      page: 1,
      positionGroupId: '', // เก็บ id ที่จะลบ
      dialogConfirmDel: false // dialog ยืนยันการลบ
    }
  },
  components: {
    OverlayLoading,
    DialogAddGroup,
    DialogUpdateGroupPosition,
    DialogAddPositionInGroup,
    DialogUpdateGroupName
  },
  created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.tokenUser = this.$store.state.token
    this.initDataTable()
    this.getSelectGroupName()
  },
  beforeDestroy () {
    EventBus.$off('closedialogAddGroup')
    EventBus.$off('closedialogAddPositionInGroup')
    EventBus.$off('closedialogEditPositionLevel')
    EventBus.$off('callDialogAddPositionInGroup')
    EventBus.$off('callDialogUpdateGroupName')
    EventBus.$off('closedialogUpdateGroupName')
    EventBus.$off('refreshTablePositionLevelGroup')
  },
  mounted () {
    EventBus.$on('refreshTablePositionLevelGroup', () => {
      this.positionGroupName = ''
      this.initDataTable()
      this.getSelectGroupName()
    })
    EventBus.$on('closedialogAddPositionInGroup', this.closedDialogAddPositionInGroup)
    EventBus.$on('closedialogAddGroup', this.addPositionLevel)
    EventBus.$on('closedialogEditPositionLevel', this.editPositionLevel)
    EventBus.$on('callDialogAddPositionInGroup', this.callDialogAddPositionInGroup)
    EventBus.$on('callDialogUpdateGroupName', this.callDialogUpdateGroupName)
    EventBus.$on('closedialogUpdateGroupName', this.closedDialogUpdateGroupName)
  },
  methods: {
    searchFilterData () {
      this.total = -1
      this.perPage = 15
      this.page = 1
      this.initDataTable()
    },
    // handleMenuEdit (list, item) {
    //   switch (list.type) {
    //     case 'viewPositionInGroup':
    //       break
    //     case 'editGroupName':
    //       EventBus.$emit(
    //         'opendialogUpdateGroupName',
    //         item
    //       )
    //       break
    //     case 'editPositionInGroup':
    //       this.editPositionInGroup(item)
    //       // EventBus.$emit(
    //       //   'opendialogUpdatePositionLevel',
    //       //   item
    //       // )
    //       break
    //     default: break
    //   }
    // },
    openDialogAddPositionInGroup (item) {
      EventBus.$emit('opendialogUpdateGroupPosition', item)
    },
    clearValue () {
      this.positionGroupName = ''
      this.initDataTable()
      this.getSelectGroupName()
    },
    changePerPage (value) {
      this.perPage = value
      this.initDataTable()
      this.getSelectGroupName()
    },
    changePage (value) {
      this.page = value
      this.initDataTable()
      this.getSelectGroupName()
    },
    addPositionLevel () {
      this.positionGroupName = ''
      this.initDataTable()
      this.getSelectGroupName()
    },
    editPositionLevel () {
      this.positionGroupName = ''
      this.initDataTable()
      this.getSelectGroupName()
    },
    closedDialogAddPositionInGroup () {
      this.positionGroupName = ''
      this.initDataTable()
      this.getSelectGroupName()
    },
    callDialogAddPositionInGroup (value) {
      EventBus.$emit('opendialogAddPositionInGroup', value)
    },
    callDialogUpdateGroupName (value) {
      EventBus.$emit('opendialogUpdateGroupName', value)
    },
    closedDialogUpdateGroupName () {
      this.positionGroupName = ''
      this.initDataTable()
      this.getSelectGroupName()
    },
    async getSelectGroupName (value) {
      const positionSearchGroupName = value && value !== '' ? value : ''
      if (this.debounce) {
        clearTimeout(this.debounce)
      }
      this.debounce = setTimeout(async () => {
        try {
          const res = await searchPositionLevelGroup(positionSearchGroupName, this.tokenUser)
          if (res.success) {
            this.positionGroupNameList = res.result
          }
        } catch (error) {
          console.error(error)
        }
      }, this.debounceTime)
    },
    async initDataTable () {
      this.loading = true
      this.groupPositionLevelList = []
      const temp = []
      const page = this.page
      const limit = this.perPage
      const search = this.positionGroupName
      const token = this.tokenUser

      try {
        const res = await getPositionLevelGroupList(page, limit, search, token)
        if (res.success) {
          res.result.map((el, index) => {
            temp.push({
              no: index + 1,
              ...el
            })
          })
          this.total = res?.count || -1
          this.groupPositionLevelList = temp
          this.computeData(this.groupPositionLevelList)
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }

      // try {
      //   const res = await getPositonsLevel(obj, token)
      //   if (res.success) {
      //     res.result.map((el, index) => {
      //       temp.push({
      //         no: index + 1,
      //         ...el
      //       })
      //     })
      //     this.total = res?.count || -1
      //     this.groupPositionLevelList = temp
      //     this.computeData(this.groupPositionLevelList)
      //   } else {
      //     this.groupPositionLevelList = []
      //   }
      // } catch (error) {
      //   console.log(error)
      // } finally {
      //   this.loading = false
      // }
    },
    addDialog () {
      EventBus.$emit(
        'opendialogAddGroup',
        true
      )
    },
    editPositionInGroup (item) {
      EventBus.$emit(
        'opendialogUpdateGroupPosition',
        item
      )
    },
    deleteGroup (id) {
      this.positionGroupId = id
      this.dialogConfirmDel = true
    },
    async deletePositionData () {
      try {
        const res = await deletePositionGroup(this.positionGroupId, this.tokenUser)
        if (res.success) {
          swal('สำเร็จ', 'คุณได้ทำการลบข้อมูลเรียบร้อยแล้ว', 'success', {
            button: false,
            timer: 2000
          })
          this.dialogConfirmDel = false
          this.positionGroupName = ''
          this.positionGroupId = ''
          this.initDataTable()
          this.getSelectGroupName()
          this.loading = false
        } else {
          this.dialogConfirmDel = false
          swal('ผิดพลาด', 'ไม่สามารถลบข้อได้ กรุณาลองใหม่', 'error', {
            button: false,
            timer: 2000
          })
        }
      } catch (error) {
        this.dialogConfirmDel = false
        swal('ผิดพลาด', 'ไม่สามารถลบข้อได้ กรุณาลองใหม่', 'error', {
          button: false,
          timer: 2000
        })
        console.log(error)
      }
    },
    async computeData (item) {
      await item.map(e => {
        e.createAt = moment(e.createAt).format('DD/MM/YYYY HH:mm น.')
        e.updateAt = moment(e.updateAt).format('DD/MM/YYYY HH:mm น.')
      })
    }
  }
}
</script>

<style scoped>
.v-input__slot {
  align-items: center;
  color: inherit;
  display: flex;
  margin-bottom: 0px !important;
  min-height: inherit;
  position: relative;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  width: 100%;
}

.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0px !important;
}

.v-text-field__details {
  min-height: 0px !important;
}

.theme--light.v-text-field--outlined > .v-input__control > .v-input__slot {
  /* font-family: 'Sarabun', sans-serif; */
  font-family: 'Sarabun', sans-serif !important;
  font-weight: normal;
  font-size: 14px;
}

.v-menu__content {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 14px;
}

.filter-chip_department {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
  font-size: 14px;
  color: #fff;
}

.filter-title-textfield {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px;
  color: #000;
}
.ra-button-employee {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 9px 24px;
  width: 157px;
  height: 36px;
  background: #2BA197;
  border-radius: 4px;
}
.ra-text-in-button-employee {
  font-family: 'Sarabun', sans-serif;
  /* font-weight: normal; */
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
}
</style>
<style>
/* table */
.theme--light.v-pagination .v-pagination__item--active {
    background: #2BA197 !important;
    color: #FFFFFF;
}
.v-pagination__item {
    background: transparent;
    border-radius: 4px;
    font-size: 14px;
    height: 30px;
    margin: 0.3rem;
    min-width: 30px;
    padding: 0 5px;
    text-decoration: none;
    transition: 0.3s cubic-bezier(0, 0, 0.2, 1);
    width: auto;
    box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
}
.v-pagination__navigation {
    box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    height: 30px;
    width: 30px;
    margin: 0.3rem 10px;
}
/* end */
</style>
